'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTime$002dRange from "./presto.types$-Time-Range.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TimeRange$() {
}
export { $c_Lpresto_types$TimeRange$ as $c_Lpresto_types$TimeRange$ };
$p = $c_Lpresto_types$TimeRange$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TimeRange$;
/** @constructor */
function $h_Lpresto_types$TimeRange$() {
}
export { $h_Lpresto_types$TimeRange$ as $h_Lpresto_types$TimeRange$ };
$h_Lpresto_types$TimeRange$.prototype = $p;
$p.ctI = (function(range) {
  if (range.uj.cL2(range.uk)) {
    return true;
  } else {
    var x = range.uk;
    var x$2 = range.uj;
    return ((x === null) ? (x$2 === null) : x.i(x$2));
  }
});
$p.cHB = (function(x$0) {
  return new $j_presto$002etypes$0024$002dTime$002dRange.$c_Lpresto_types$TimeRange(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_types$TimeRange$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TimeRange$, "presto.types$TimeRange$", ({
  a2k: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$TimeRange$ as $d_Lpresto_types$TimeRange$ };
var $n_Lpresto_types$TimeRange$;
function $m_Lpresto_types$TimeRange$() {
  if ((!$n_Lpresto_types$TimeRange$)) {
    $n_Lpresto_types$TimeRange$ = new $c_Lpresto_types$TimeRange$();
  }
  return $n_Lpresto_types$TimeRange$;
}
export { $m_Lpresto_types$TimeRange$ as $m_Lpresto_types$TimeRange$ };
//# sourceMappingURL=presto.types$-Time-Range$.js.map
